/**
 * Self-reported marketing attribution ("How did you hear about Yardzen?").
 *
 * Asked once per lead, on whichever lead-capture form the visitor hits first
 * (design profile quiz, YardAI, unified funnel). This is the *self-reported*
 * channel — distinct from `leadSource` on CustomerLeads, which records the
 * Yardzen surface that captured the lead.
 *
 * The labels below are the contract: they are the exact option text marketing
 * requested, and they are what the HubSpot enumeration property's option labels
 * must be, because the sync derives HubSpot internal values from the label via
 * `hubspotOptionValue`. Changing a label here changes the value HubSpot
 * receives — add options rather than reword existing ones.
 */
export const HEARD_ABOUT_US_QUESTION = "How did you hear about Yardzen?";

export const HEARD_ABOUT_US_OPTIONS = [
  "Friend or neighbor",
  "Instagram",
  "Facebook",
  "Google",
  "Pinterest",
  "AI assistant like ChatGPT, Perplexity, Gemini, etc.",
  "Mail",
  "Press Mention",
  "Television/Streaming",
  "Podcast",
  "Other",
] as const;

export type HeardAboutUsOption = (typeof HEARD_ABOUT_US_OPTIONS)[number];

/** True when `value` is one of the options above. Answers that fail this are
 *  dropped rather than forwarded, so a stale client cannot poison HubSpot. */
export function isHeardAboutUsOption(
  value: unknown,
): value is HeardAboutUsOption {
  return (
    typeof value === "string" &&
    (HEARD_ABOUT_US_OPTIONS as readonly string[]).includes(value)
  );
}
